import { Link } from 'react-router-dom';
import { ROUTES } from '@constants';

const Footer = () => {
  return (
    <footer className="bg-white border-t border-gray-200 py-4 mt-auto">
      <div className="container mx-auto px-4">
        <div className="flex flex-col md:flex-row items-center justify-between gap-4">
          <p className="text-sm text-gray-600">
            &copy; {new Date().getFullYear()} F.O.W. All rights reserved.
          </p>
          
          <div className="flex items-center gap-6">
            <Link
              to={ROUTES.TERMS_AND_CONDITIONS}
              className="text-sm text-gray-600 hover:text-primary-600 transition-colors"
            >
              Terms & Conditions
            </Link>
            <Link
              to={ROUTES.PRIVACY_POLICY}
              className="text-sm text-gray-600 hover:text-primary-600 transition-colors"
            >
              Privacy Policy
            </Link>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
